import * as THREE from "three/webgpu";
import { SELECTION_OUTLINE_COLOR } from "./selectionOutlinePass.ts";

export const HIDDEN_SELECTION_GHOST_OPACITY = 0.28;
export const HIDDEN_SELECTION_GHOST_RENDER_ORDER = 2;

export const HIDDEN_SELECTION_GHOST_MAT = new THREE.MeshBasicMaterial({
  color: SELECTION_OUTLINE_COLOR,
  transparent: true,
  opacity: HIDDEN_SELECTION_GHOST_OPACITY,
  depthTest: false,
  depthWrite: false,
  side: THREE.DoubleSide,
  toneMapped: false,
});

HIDDEN_SELECTION_GHOST_MAT.forceSinglePass = true;

export function shouldShowHiddenSelectionGhost({
  selected,
  effectiveVisible,
  showSceneInteraction,
}: {
  selected: boolean;
  effectiveVisible: boolean;
  showSceneInteraction: boolean;
}): boolean {
  return selected && !effectiveVisible && showSceneInteraction;
}
